import React from "react";
import { Select } from "@outpave/ds";
import { useTranslation } from "react-i18next";

interface UserGroupSelectProps {
  roleSelected: string;
  onSelectRole: (role: string) => void;
  error?: string;
  policy?: unknown;
}

const UserGroupSelect: React.FC<UserGroupSelectProps> = ({
  roleSelected,
  onSelectRole,
  error,
  policy,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      label={t("User Group")}
      helperText={t("To whom these requirements will apply?")}
      options={[
        { id: "Employee", label: t("Employee") },
        { id: "Contractor", label: t("Contractor") },
        { id: "Manager", label: t("Manager") },
        { id: "Admin", label: t("Administrator") },
      ]}
      value={roleSelected || null}
      onChange={(role) => onSelectRole(role ?? "")}
      errorText={error}
      disabled={Boolean(policy)}
      required
      fullWidth
    />
  );
};

export default UserGroupSelect;
